var _circle, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "url(#paint0_linear_13_7398)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0704 39.5973H106.929H108.411V39.6291C126.449 40.4046 140.835 55.2738 140.835 73.503C140.835 81.9702 137.731 89.7124 132.599 95.6541C142.849 101.704 149.726 112.862 149.726 125.625C149.726 144.803 134.202 160.356 115.035 160.403V160.403H63.087V160.054H63.0869V57.0296V39.5973H93.0704ZM92.5478 61.8685C92.5478 59.9154 93.8589 58.2684 95.6489 57.7598C97.1134 57.2839 98.7862 57.6277 99.9497 58.7911L111.46 70.3012C111.556 70.3818 111.65 70.4674 111.74 70.5579C113.392 72.2094 113.392 74.8869 111.74 76.5383L100.019 88.26C99.1665 89.1121 98.0411 89.5246 96.9245 89.4973C96.8894 89.4982 96.8541 89.4986 96.8187 89.4986C94.4599 89.4986 92.5478 87.5865 92.5478 85.2277V61.8685ZM112.944 137.26C112.944 139.213 111.632 140.86 109.842 141.369C108.378 141.845 106.705 141.501 105.542 140.337L94.033 128.829C93.9361 128.748 93.8419 128.662 93.7508 128.571C92.0993 126.919 92.0993 124.242 93.7508 122.59L105.472 110.868C106.325 110.016 107.45 109.604 108.566 109.631C108.588 109.631 108.609 109.63 108.631 109.63C108.645 109.63 108.659 109.63 108.673 109.63C111.031 109.63 112.944 111.542 112.944 113.901V137.26Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_7398",
    x1: 0.329313,
    y1: 22.8238,
    x2: 245.23,
    y2: 141.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.053951,
    stopColor: "#6D5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559189,
    stopColor: "#E86EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923794,
    stopColor: "#FFD66E"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBob);
export default __webpack_public_path__ + "static/media/bob.4abcb057061aef59a2139341cfe71429.svg";
export { ForwardRef as ReactComponent };